import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";
import { categoryNameMap } from "@/mocks/topics";

interface HotRankingProps {
  topics: Topic[];
}

export default function HotRanking({ topics }: HotRankingProps) {
  return (
    <section className="border-b border-background-200 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.3em] text-primary-600">
              HOT RANKING
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              本周读者反复翻看的档案
            </h2>
          </div>
          <Link
            to="/topics?sort=hot"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
          >
            查看完整榜单
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-x-12 lg:grid-cols-2">
          <div className="divide-y divide-background-200 border-t border-background-200">
            {topics.slice(0, 4).map((topic, index) => (
              <article key={topic.id} className="group flex items-start gap-5 py-5">
                <span className="font-heading text-2xl font-bold text-background-400">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                      {categoryNameMap[topic.categoryId]}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-fire-line text-primary-500" />
                      {(topic.hot / 1000).toFixed(1)}k
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    <Link to={`/topics/${topic.slug}`}>{topic.title}</Link>
                  </h3>
                </div>
              </article>
            ))}
          </div>
          <div className="divide-y divide-background-200 border-t border-background-200">
            {topics.slice(4, 8).map((topic, index) => (
              <article key={topic.id} className="group flex items-start gap-5 py-5">
                <span className="font-heading text-2xl font-bold text-background-400">
                  {String(index + 5).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                      {categoryNameMap[topic.categoryId]}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-fire-line text-primary-500" />
                      {(topic.hot / 1000).toFixed(1)}k
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    <Link to={`/topics/${topic.slug}`}>{topic.title}</Link>
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}